var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,0A14.5,14.5,0,1,0,29,14.5,14.51,14.51,0,0,0,14.5,0Zm0,28A13.5,13.5,0,1,1,28,14.5,13.52,13.52,0,0,1,14.5,28ZM21,14.19a.5.5,0,0,1-.5.5H9.74l4.11,4a.5.5,0,0,1-.35.86.54.54,0,0,1-.35-.14l-5-4.81h0a.6.6,0,0,1-.09-.13l0,0s0,0,0-.05a.58.58,0,0,1,0-.14H8s0,0,0-.07A.35.35,0,0,1,8,14a.29.29,0,0,1,.07-.12l0,0h0l4.49-4.69a.5.5,0,0,1,.72.7L9.67,13.69H20.5A.5.5,0,0,1,21,14.19Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftO);
export default __webpack_public_path__ + "static/media/arrow-left-o.a631c46526f026bb4d22e100b4d58952.svg";
export { ForwardRef as ReactComponent };